/**
 * Organization / パンくず JSON-LD 用（Schema.org 定義に準拠）
 * 公式 SNS URL はここを正とし、フッター・JSON-LD の sameAs で同じ値を参照する。
 */
export const SITE_DEFAULT_ORIGIN = 'https://socialtrip.net';

/** ビルド時に Netlify 等で上書き可能（Vite の VITE_ プレフィックス） */
const instagramUrlFromEnv = (import.meta.env.VITE_SOCIAL_INSTAGRAM_URL as string | undefined)?.trim() ?? '';

/**
 * 公式 Instagram プロフィール（末尾スラッシュ付きで統一）
 * フッターアイコンと Organization JSON-LD の sameAs は必ずこの URL を使う。
 */
export const OFFICIAL_INSTAGRAM_URL =
  instagramUrlFromEnv || 'https://www.instagram.com/socialtrip.ai/';

/** フッター SNS リンク（画面表示用） */
export const SOCIAL_LINKS = {
  instagram: OFFICIAL_INSTAGRAM_URL,
} as const;

/** Organization JSON-LD の sameAs（公式 SNS。フッター Instagram と同一） */
export function getOrganizationSameAs(): string[] {
  return OFFICIAL_INSTAGRAM_URL ? [OFFICIAL_INSTAGRAM_URL] : [];
}

export const ORGANIZATION = {
  /** サイト名（ブランド） */
  name: 'Social Trip',
  /** 法務表記（運営会社） */
  legalName: 'Force Agent合同会社',
  /** フッターと同一のロゴ画像 */
  logoPath: '/images/995a9d39fcc556866eb42c83f07dbc9c.png',
  contactEmail: 'support@socialtrip.jp',
  contactType: 'customer service' as const,
};
